// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa70e437","239":"fee664f9","667":"a294b2f2"}[chunkId] + ".chunk.js";
};